module.exports = __webpack_public_path__ + "img/set cortesia.7dd69898.jpeg";